import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { FormInstance } from "antd";

import { MergedColumnType } from "../../../../../ui/table/utils/types";
//Locale
import "dayjs/locale/uk";

dayjs.extend(customParseFormat);
dayjs.locale("uk");

export const setAdministration: Record<
  string,
  (form: FormInstance, rowData: MergedColumnType) => void
> = {
  "/administration/configuring-page-access": (form, rowData) => {
    form.setFieldsValue({
      role: { value: rowData.roleId, label: rowData.Role },
      pages: [{ value: rowData.routeId, label: rowData.Pages }],
      access: rowData.Access,
    });
  },
  "/administration/button-access-settings": (form, rowData) => {
    form.setFieldsValue({
      role: { value: rowData.roleId, label: rowData.Role },
      pages: [{ value: rowData.routeId, label: rowData.Pages }],
      buttons: [{ value: rowData.buttonId, label: rowData.Buttons }],
      access: rowData.Access,
    });
  },
  "/administration/server-settings": (form, rowData) => {
    form.setFieldsValue({
      serverName: rowData.ServerName,
      serverCode: rowData.ServerCode,
      imapAddress: rowData.Imap_host,
      imapPort: rowData.Imap_port,
      imapConnectionSecurity: [{ value: rowData.ss_options_imap_id, label: rowData.name_ss_options_imap }],
      smtpAddress: rowData.smtp_host,
      smtpPort: rowData.smtp_port,
      smtpConnectionSecurity: [{ value: rowData.ss_options_smtp_id, label: rowData.name_ss_options_smtp }],
      authorization: rowData.smtp_Auth,
    });
  },
  "/administration/users": (form, rowData) => {
    form.setFieldsValue({
      fullName: rowData.clerksId,
      structuralUnit: `${rowData.NameDepartment ?? ""}\\${
        rowData.NamePost ?? ""
      }`,
      login: rowData.UserName,
      email: rowData.email,
      role: { value: rowData.roleId, label: rowData.Name_prav },
      webVersion: rowData.WebAdd,
      allowAccess: rowData.del,
      allowAccessHidden: rowData.del,
    });
  },
  "/administration/barcode-application-options": (form, rowData) => {
    form.setFieldsValue({
      department: rowData.sta_otdel_id,
      documentType: { value: rowData.eta_const_typeDoc_id, label: rowData.name_const_typeDoc },
      arrangement: { value: rowData.sta_BarCode_Placement_id, label: rowData.name_placement },
      barcodeHeight: rowData.barcodeHeight,
      imageFormat: { value: rowData.image_format, label: rowData.image_format },
      withDigitalValue: rowData.isShowDataCode,
      height: rowData.Height,
      width: rowData.Width,
      font: rowData.font_size,
      addBarcodeWithElectronicSignature: rowData.isInsertInSignInfo,
      columnWidthSignatureInformation: rowData.WidthColumnSignInfo,
    });
  },
  "/administration/mailboxes": (form, rowData) => {
    form.setFieldsValue({
      server: rowData.mail_Server_id,
      mailboxe: rowData.email,
      userName: rowData.SenderName,
      organization: rowData.Organization,
      incomingMailUser: rowData.Imap_user,
      passwordImap: rowData.Imap_pass,
      outgoingMailUser: rowData.smtp_user,
      passwordSmtp: rowData.smtp_pass,
    });
  },
  "/administration/mailboxes-by-user": (form, rowData) => {
    form.setFieldsValue({
      mailboxe: rowData.email_id,
      mailUser: rowData.name_user_mail_id,
    });
  },
};
